import { useCallback } from 'react';
import { useLang } from 'hooks/lang';

import { RadioInput } from 'components/Blocks';

import { cn } from 'styles';

interface ApproveRejectButtonsProps {
  children?: never;
  value: boolean | null;
  onChange: (state: boolean) => void;
  disabled?: boolean;
  className?: string;
}

export function ApproveRejectButtons({
  value,
  onChange,
  disabled,
  className,
}: ApproveRejectButtonsProps): JSX.Element {
  const { t } = useLang();

  const handleChange = useCallback(
    (value: string) => {
      if (!value) return;

      onChange(value === 'true' ? true : false);
    },
    [onChange],
  );

  const textValue = value === true ? 'true' : value === false ? 'false' : '';

  return (
    <RadioInput
      containerClassName="flex flex-row gap-0"
      className={cn('w-24 border p-2 text-sm', className)}
      addDot={false}
      disabled={disabled}
      onChangeDirect={handleChange}
      value={textValue}
      options={[
        {
          label: t('accept'),
          value: 'true',
          className: cn(
            'rounded-l-full',
            value === true && 'border-success bg-success-light/20 text-success',
          ),
        },
        {
          label: t('reject'),
          value: 'false',
          className: cn(
            'rounded-r-full',
            value === false &&
              'border-destructive-light bg-destructive-light/20 text-destructive-light',
          ),
        },
      ]}
    />
  );
}
